<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Lotti</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Eliminati:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">Con Eliminati</option>
          <option value="only">Solo Eliminati</option>
        </select>
      </search-filter>
      <inertia-link class="btn-indigo" :href="route('batches.create')">
        <span>Crea</span>
        <span class="hidden md:inline">Lotto</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-3">Nome</th>
          <th class="px-6 pt-6 pb-3">Numero Prodotti</th>
          <th v-if="user.id == 18 || user.id == 1 || user.id == 27 || user.id == 24" class="px-6 pt-6 pb-3">Valore</th>
          <th class="px-6 pt-6 pb-3">Data creazione</th>
          <th class="px-6 pt-6 pb-3">Store</th>
          <!-- <th class="px-6 pt-6 pb-3">Data Carico</th>
          <th class="px-6 pt-6 pb-3">Data Scarico</th>
          <th class="px-6 pt-6 pb-3">Prezzo Totale Scarico</th> -->
        </tr>
        <tr v-for="batch in batches.data" :key="batch.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('batches.edit', batch.id)">
              {{ batch.nome }}
              <icon v-if="batch.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('batches.edit', batch.id)" tabindex="-1">
              <div v-if="batch.count_product">
                {{ batch.count_product }}
              </div>
            </inertia-link>
          </td>
          <td v-if="user.id == 18 || user.id == 1 || user.id == 27 || user.id == 24" class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('batches.edit', batch.id)">
              {{ batch.total_product.toFixed(0) }} €
              <icon v-if="batch.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('batches.edit', batch.id)">
              {{ batch.created_at }}
              <icon v-if="batch.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('batches.edit', batch.id)">
              {{ batch.organization }}
              <icon v-if="batch.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <!-- <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('batches.edit', batch.id)" tabindex="-1">
              {{ batch.data_carico }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('batches.edit', batch.id)" tabindex="-1">
              {{ batch.data_scarico }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('batches.edit', batch.id)" tabindex="-1">
              {{ batch.prezzo_totale_scarico }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('batches.edit', batch.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td> -->
        </tr>
        <tr v-if="batches.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Nessun lotto trovato</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="batches.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  computed: {
    user() {
      return this.$page.props.auth.user
    },
  },
  metaInfo: { title: 'Lotti' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    batches: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('batches'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
